export default "__VITE_ASSET__CrRhDnml__"